import { RefreshCcw } from 'lucide-react';
import { generateSecret } from 'shared/lib/generateSecret';
import { Button } from 'shared/ui/button';
interface GenerateSecretProps {
  setValue: (secret: string) => void;
}
export const GenerateSecret = ({
  setValue
}: GenerateSecretProps) => {
  const handleClick = () => {
    setValue(generateSecret());
  };
  return <Button type="button" variant="ghost" className="size-5 p-0" onClick={handleClick} data-sentry-element="Button" data-sentry-component="GenerateSecret" data-sentry-source-file="generate-secret.tsx">
      <RefreshCcw size={16} data-sentry-element="RefreshCcw" data-sentry-source-file="generate-secret.tsx" />
    </Button>;
};